// GENERATED FILE — do not edit by hand.
// Source: data/photon/releases/*.json (contract: data/photon/release.schema.json)
// Regenerate: pnpm photon:releases (runs automatically on predev/prebuild).

import type {
  BenchmarkDataset,
  ModelFamily,
  ReleaseModel,
  SupportRow,
  Update,
} from "../release-types";
import { familyDescription } from "../editorial";

/** All declared models (id, family, release, variant), name order. */
export const RELEASE_MODELS: ReleaseModel[] = [
  {
    "id": "gemma-4-e2b",
    "name": "Gemma 4 E2B",
    "family": "Gemma",
    "release": "4",
    "variant": "E2B",
    "revision": "e83c7d4",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "gemma-4-e4b",
    "name": "Gemma 4 E4B",
    "family": "Gemma",
    "release": "4",
    "variant": "E4B",
    "revision": "f26a9b3",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "moondream-2",
    "name": "Moondream 2",
    "family": "Moondream",
    "release": "2",
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "moondream-3",
    "name": "Moondream 3",
    "family": "Moondream",
    "release": "3",
    "revision": "9f2c1e4",
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-0-8b",
    "name": "Qwen 3.5 0.8B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "0.8B",
    "revision": "a41d8b2",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-2b",
    "name": "Qwen 3.5 2B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "2B",
    "revision": "b77e0c5",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-4b",
    "name": "Qwen 3.5 4B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "4B",
    "revision": "c19f3a8",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-9b",
    "name": "Qwen 3.5 9B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "9B",
    "revision": "d55b2e1",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-6-0-8b",
    "name": "Qwen 3.6 0.8B",
    "family": "Qwen 3",
    "release": "3.6",
    "variant": "0.8B",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  }
];

/** Support matrix across all releases, status-major then model order. */
export const SUPPORT_MATRIX: SupportRow[] = [
  {
    "id": "gemma-4-e2b-h100",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e4b-h100",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-a10",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "A10 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-a40",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "A40",
    "target": "NVIDIA Ampere",
    "testedHardware": "A40 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-a100",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "A100 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-gh200",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "GH200",
    "target": "NVIDIA Hopper",
    "testedHardware": "GH200 96GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-h100",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-h200",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "H200",
    "target": "NVIDIA Hopper",
    "testedHardware": "H200 SXM 141GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-jetson-agx-orin",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "Jetson AGX Orin",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson AGX Orin 64GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-jetson-orin-nano",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "Jetson Orin Nano",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin Nano 8GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-jetson-orin-nx",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "Jetson Orin NX",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin NX 16GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-l4",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L4 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-l40s",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "L40S",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L40S 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-rtx-30-series",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "RTX 30 series",
    "target": "NVIDIA Ampere",
    "testedHardware": "RTX 3090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-rtx-4090",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream",
    "chip": "RTX 4090",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "RTX 4090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-a10",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "A10 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-a40",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "A40",
    "target": "NVIDIA Ampere",
    "testedHardware": "A40 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-a100",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "A100 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-gh200",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "GH200",
    "target": "NVIDIA Hopper",
    "testedHardware": "GH200 96GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-h100",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-h200",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "H200",
    "target": "NVIDIA Hopper",
    "testedHardware": "H200 SXM 141GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-jetson-agx-orin",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "Jetson AGX Orin",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson AGX Orin 64GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-l4",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L4 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-l40s",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "L40S",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L40S 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-rtx-30-series",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "RTX 30 series",
    "target": "NVIDIA Ampere",
    "testedHardware": "RTX 3090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-rtx-4090",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream",
    "chip": "RTX 4090",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "RTX 4090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-h100",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-2b-h100",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-4b-h100",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-9b-h100",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-6-0-8b-h100",
    "model": "Qwen 3.6 0.8B",
    "modelSlug": "qwen-3-6-0-8b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  }
];

/** Production model families for the /photon cards. */
export const MODEL_FAMILIES: ModelFamily[] = [
  {
    id: "moondream",
    name: "Moondream",
    versions: [],
    releases: [
  {
    "name": "2",
    "status": "production"
  },
  {
    "name": "3",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Moondream"),
    capabilities: [
  "Query",
  "Caption",
  "Detect",
  "Point",
  "Segment"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "A10 24GB",
  "A40 48GB",
  "A100 80GB",
  "GH200 96GB",
  "H100 SXM 80GB",
  "H200 SXM 141GB",
  "Jetson AGX Orin 64GB",
  "Jetson Orin Nano 8GB",
  "Jetson Orin NX 16GB",
  "L4 24GB",
  "L40S 48GB",
  "RTX 3090 24GB",
  "RTX 4090 24GB"
],
    introducedIn: "Photon 1.0",
  },
  {
    id: "qwen-3",
    name: "Qwen 3",
    versions: [
  "0.8B",
  "2B",
  "4B",
  "9B"
],
    releases: [
  {
    "name": "3.5",
    "status": "production"
  },
  {
    "name": "3.6",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Qwen 3"),
    capabilities: [
  "Query",
  "Caption"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "H100 SXM 80GB"
],
    introducedIn: "Photon 2.0",
  },
  {
    id: "gemma",
    name: "Gemma",
    versions: [
  "E2B",
  "E4B"
],
    releases: [
  {
    "name": "4",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Gemma"),
    capabilities: [
  "Query",
  "Caption"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "H100 SXM 80GB"
],
    introducedIn: "Photon 2.0",
  },
];

/** Releases with a complete public benchmark, newest first. */
export const BENCHMARKS: BenchmarkDataset[] = [
  {
    "id": "2.0",
    "environment": {
      "label": "H100",
      "gpu": "NVIDIA H100 SXM 80GB",
      "gpuSku": "H100 SXM5 80GB HBM3",
      "driver": "590.42.06",
      "cuda": "13.1",
      "runtimes": {
        "photon": "Photon 2.0",
        "vllm": "vLLM 0.25.1",
        "sglang": "SGLang 0.5.3"
      },
      "workload": "ChartQA 512-request slice",
      "concurrency": [
        1,
        2,
        4,
        8
      ],
      "date": "2026-08-03",
      "repro": "python -m moondream.bench --suite h100-chartqa-512 --engines photon,vllm,sglang --seed 20260803",
      "sampling": {
        "throughput": "512 matched requests per cell · pairwise Photon-to-runtime ratio · one captured SGLang run · published vLLM launch ratios",
        "latency": "concurrency 1 · 512 matched requests · client-observed completion time · one captured SGLang run",
        "coldStart": "cold process · warm model cache · total from process start to first response · one recorded SGLang run",
        "resources": "Photon · concurrency 8 · sustained 10 minutes per model · NVML sampled at 1 Hz · energy = incremental joules over idle ÷ output tokens"
      },
      "qualityCaveat": "Runtime performance, not model quality. The tested Qwen and Gemma configurations score below 5% ChartQA exact-match and are included as matched runtime controls.",
      "disclosures": [
        "H100 SXM5 80GB HBM3 · driver 590.42.06 · CUDA 13.1",
        "Identical 512-request stream replayed to each engine pair",
        "SGLang request identity, prompt, ground truth, and input-token counts match Photon in all 24 cells",
        "SGLang 0.5.3 does not support Moondream, so its comparison covers Qwen 3.5 and Gemma 4 only",
        "Matched model revisions across engines · one physical GPU per engine pair · sequential runs",
        "Prefix cache disabled on compared engines",
        "Photon measured in-process; vLLM and SGLang measured over HTTP — their native deployment forms",
        "Photon output-token totals ranged from 9.6% lower to 5.2% higher than SGLang across cells; throughput is completed requests per second",
        "SGLang resource telemetry was not captured and is not included"
      ]
    },
    "models": [
      {
        "id": "moondream-3",
        "model": "Moondream 3",
        "family": "Moondream",
        "revision": "9f2c1e4"
      },
      {
        "id": "qwen-3-5-0-8b",
        "model": "Qwen 3.5 0.8B",
        "family": "Qwen 3",
        "revision": "a41d8b2"
      },
      {
        "id": "qwen-3-5-2b",
        "model": "Qwen 3.5 2B",
        "family": "Qwen 3",
        "revision": "b77e0c5"
      },
      {
        "id": "qwen-3-5-4b",
        "model": "Qwen 3.5 4B",
        "family": "Qwen 3",
        "revision": "c19f3a8"
      },
      {
        "id": "qwen-3-5-9b",
        "model": "Qwen 3.5 9B",
        "family": "Qwen 3",
        "revision": "d55b2e1"
      },
      {
        "id": "gemma-4-e2b",
        "model": "Gemma 4 E2B",
        "family": "Gemma",
        "revision": "e83c7d4"
      },
      {
        "id": "gemma-4-e4b",
        "model": "Gemma 4 E4B",
        "family": "Gemma",
        "revision": "f26a9b3"
      }
    ],
    "families": [
      "Moondream",
      "Qwen 3",
      "Gemma"
    ],
    "throughput": [
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 2.33,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.68,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.43,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.34,
        "modelId": "moondream-3"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.54,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.5662,
        "photonRps": 2.02805,
        "baselineRps": 1.294924,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.48,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.5066,
        "photonRps": 3.655267,
        "baselineRps": 2.426124,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.48,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.543,
        "photonRps": 6.535147,
        "baselineRps": 4.23536,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.29,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.3967,
        "photonRps": 9.607568,
        "baselineRps": 6.878563,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.29,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.4448,
        "photonRps": 1.250415,
        "baselineRps": 0.865487,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.28,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.4423,
        "photonRps": 2.313517,
        "baselineRps": 1.604017,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.3,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.5138,
        "photonRps": 4.30569,
        "baselineRps": 2.844349,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.2,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.4239,
        "photonRps": 6.808389,
        "baselineRps": 4.78165,
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.25,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.345,
        "photonRps": 0.713464,
        "baselineRps": 0.530443,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.21,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.3102,
        "photonRps": 1.325225,
        "baselineRps": 1.011442,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.13,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.2197,
        "photonRps": 2.23729,
        "baselineRps": 1.834367,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.07,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.2334,
        "photonRps": 3.925087,
        "baselineRps": 3.182215,
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.1,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.1417,
        "photonRps": 0.388802,
        "baselineRps": 0.340559,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.1,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.1545,
        "photonRps": 0.754332,
        "baselineRps": 0.653366,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.1,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.1433,
        "photonRps": 1.394992,
        "baselineRps": 1.220135,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.04,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.1422,
        "photonRps": 2.484537,
        "baselineRps": 2.175279,
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.27,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.5475,
        "photonRps": 0.743448,
        "baselineRps": 0.480405,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.2,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.5018,
        "photonRps": 1.353055,
        "baselineRps": 0.900934,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.12,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.4131,
        "photonRps": 2.355024,
        "baselineRps": 1.666528,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.01,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.3227,
        "photonRps": 3.961057,
        "baselineRps": 2.994677,
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "vllm",
        "multiple": 1.17,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "multiple": 1.4048,
        "photonRps": 0.510732,
        "baselineRps": 0.363553,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 2,
        "runtime": "vllm",
        "multiple": 1.14,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 2,
        "runtime": "sglang",
        "multiple": 1.3483,
        "photonRps": 0.94395,
        "baselineRps": 0.700118,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 4,
        "runtime": "vllm",
        "multiple": 1.06,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 4,
        "runtime": "sglang",
        "multiple": 1.3148,
        "photonRps": 1.718659,
        "baselineRps": 1.307181,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 8,
        "runtime": "vllm",
        "multiple": 1.02,
        "modelId": "gemma-4-e4b"
      },
      {
        "concurrency": 8,
        "runtime": "sglang",
        "multiple": 1.2321,
        "photonRps": 2.941201,
        "baselineRps": 2.387073,
        "modelId": "gemma-4-e4b"
      }
    ],
    "latency": [
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 342.36,
          "p95": 1705.13,
          "p99": 1726.16
        },
        "baseline": {
          "p50": 583.29,
          "p95": 2555.18,
          "p99": 2606.49
        },
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 547.33,
          "p95": 2833.54,
          "p99": 2848.19
        },
        "baseline": {
          "p50": 777.35,
          "p95": 3686.93,
          "p99": 3700.84
        },
        "modelId": "qwen-3-5-2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 941.4,
          "p95": 5463.05,
          "p99": 5496.19
        },
        "baseline": {
          "p50": 1347.02,
          "p95": 6697.8,
          "p99": 6727.92
        },
        "modelId": "qwen-3-5-4b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1768.45,
          "p95": 9308.08,
          "p99": 9330.94
        },
        "baseline": {
          "p50": 2050.16,
          "p95": 10486.26,
          "p99": 10521.2
        },
        "modelId": "qwen-3-5-9b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1160.89,
          "p95": 2596.83,
          "p99": 3776.22
        },
        "baseline": {
          "p50": 1801.35,
          "p95": 3937.48,
          "p99": 6290.12
        },
        "modelId": "gemma-4-e2b"
      },
      {
        "concurrency": 1,
        "runtime": "sglang",
        "photon": {
          "p50": 1729.05,
          "p95": 4018.89,
          "p99": 5691.83
        },
        "baseline": {
          "p50": 2433.86,
          "p95": 5563.01,
          "p99": 7804.98
        },
        "modelId": "gemma-4-e4b"
      }
    ],
    "coldStart": [
      {
        "runtime": "vllm",
        "photonSeconds": 35.95,
        "baselineSeconds": 42.12,
        "modelId": "moondream-3"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 34.76,
        "baselineSeconds": 100.81,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 34.76,
        "baselineSeconds": 77.782729029,
        "baselineReadySeconds": 57.559917184,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 35.67,
        "baselineSeconds": 98.6,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 35.67,
        "baselineSeconds": 79.402581638,
        "baselineReadySeconds": 58.873479134,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 37.36,
        "baselineSeconds": 105.23,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 37.36,
        "baselineSeconds": 79.367245739,
        "baselineReadySeconds": 58.276470679,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 38.75,
        "baselineSeconds": 111.89,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 38.75,
        "baselineSeconds": 79.386563145,
        "baselineReadySeconds": 58.358772732,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 67.6,
        "baselineSeconds": 179.83,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 67.6,
        "baselineSeconds": 72.581561083,
        "baselineReadySeconds": 60.854793751,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "vllm",
        "photonSeconds": 74.04,
        "baselineSeconds": 184.53,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "sglang",
        "photonSeconds": 74.04,
        "baselineSeconds": 74.266124757,
        "baselineReadySeconds": 61.843391332,
        "modelId": "gemma-4-e4b"
      }
    ],
    "resources": [
      {
        "runtime": "photon",
        "vramGb": 21.4,
        "powerW": 342,
        "tempC": 61,
        "joulesPerToken": 0.42,
        "modelId": "moondream-3"
      },
      {
        "runtime": "vllm",
        "vramGb": 24.8,
        "powerW": 318,
        "tempC": 58,
        "joulesPerToken": 0.51,
        "modelId": "moondream-3"
      },
      {
        "runtime": "photon",
        "vramGb": 12.8,
        "powerW": 385,
        "tempC": 64,
        "joulesPerToken": 0.55,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "vllm",
        "vramGb": 16.2,
        "powerW": 296,
        "tempC": 57,
        "joulesPerToken": 0.38,
        "modelId": "qwen-3-5-0-8b"
      },
      {
        "runtime": "photon",
        "vramGb": 14.6,
        "powerW": 391,
        "tempC": 65,
        "joulesPerToken": 0.61,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "vllm",
        "vramGb": 18.9,
        "powerW": 302,
        "tempC": 58,
        "joulesPerToken": 0.44,
        "modelId": "qwen-3-5-2b"
      },
      {
        "runtime": "photon",
        "vramGb": 17.9,
        "powerW": 402,
        "tempC": 66,
        "joulesPerToken": 0.72,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "vllm",
        "vramGb": 22.4,
        "powerW": 315,
        "tempC": 59,
        "joulesPerToken": 0.57,
        "modelId": "qwen-3-5-4b"
      },
      {
        "runtime": "photon",
        "vramGb": 24.2,
        "powerW": 418,
        "tempC": 67,
        "joulesPerToken": 0.98,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "vllm",
        "vramGb": 29.6,
        "powerW": 339,
        "tempC": 61,
        "joulesPerToken": 0.83,
        "modelId": "qwen-3-5-9b"
      },
      {
        "runtime": "photon",
        "vramGb": 15.1,
        "powerW": 388,
        "tempC": 64,
        "joulesPerToken": 0.63,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "vllm",
        "vramGb": 19.4,
        "powerW": 305,
        "tempC": 58,
        "joulesPerToken": 0.47,
        "modelId": "gemma-4-e2b"
      },
      {
        "runtime": "photon",
        "vramGb": 18.4,
        "powerW": 397,
        "tempC": 65,
        "joulesPerToken": 0.75,
        "modelId": "gemma-4-e4b"
      },
      {
        "runtime": "vllm",
        "vramGb": 23.1,
        "powerW": 312,
        "tempC": 59,
        "joulesPerToken": 0.59,
        "modelId": "gemma-4-e4b"
      }
    ]
  }
];

/** The benchmark environment the performance pages default to. */
export const LATEST_BENCHMARK: BenchmarkDataset = BENCHMARKS[0];

/** Product updates across all releases, newest first. */
export const UPDATES: Update[] = [
  {
    "id": "photon-2-0-1-large-image-cpu-decode-fix",
    "date": "2026-08-04",
    "version": "2.0.1",
    "type": "fix",
    "title": "Large-image CPU decode fix",
    "impact": "Requests with images above 4 MP no longer fail on the CPU decode path before reaching the megakernel.",
    "models": [],
    "hardware": [],
    "knownLimitations": [
      "Images above 16 MP are still rejected at the API boundary."
    ],
    "links": {
      "prs": [
        {
          "label": "#431",
          "href": "https://github.com/m87-labs/kestrel/pull/431"
        }
      ]
    }
  },
  {
    "id": "photon-2-0-qwen-3-5-and-gemma-4-support",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "model",
    "title": "Qwen 3.5 and Gemma 4 support",
    "impact": "Photon 2.0 adds production support for Qwen 3.5 (0.8B-9B) and Gemma 4 E2B/E4B.",
    "models": [
      "Qwen 3.5 0.8B",
      "Qwen 3.5 2B",
      "Qwen 3.5 4B",
      "Qwen 3.5 9B",
      "Gemma 4 E2B",
      "Gemma 4 E4B"
    ],
    "hardware": [
      "H100"
    ],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally",
      "supportRows": [
        "qwen-3-5-0-8b-h100",
        "qwen-3-5-4b-h100",
        "gemma-4-e2b-h100",
        "gemma-4-e4b-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-h100-80gb-support",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "hardware",
    "title": "H100 80GB support",
    "impact": "Photon 2.0 is tested on H100 SXM 80GB across all launch models.",
    "models": [],
    "hardware": [
      "H100"
    ],
    "benchmarkImpact": "Photon was ahead in all 52 matched throughput comparisons: 28 against vLLM and 24 against SGLang, from 1.01x to 2.33x on ChartQA at concurrency 1-8.",
    "links": {
      "supportRows": [
        "moondream-3-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-lower-cold-start-time",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "performance",
    "title": "Lower cold-start time",
    "impact": "Matched cold-start tests reached first response faster on Photon than vLLM and SGLang for the launch models.",
    "models": [],
    "hardware": [
      "H100"
    ],
    "benchmarkImpact": "Photon had up to 66% lower total cold-start time than vLLM across seven models and up to 55% lower time than SGLang across six supported models."
  },
  {
    "id": "photon-2-0-moondream-3-segmentation",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "capability",
    "title": "Moondream 3 segmentation",
    "impact": "Moondream 3 on Photon serves segmentation masks alongside query, caption, detect, and point.",
    "models": [
      "Moondream 3"
    ],
    "hardware": [
      "H100"
    ],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally",
      "supportRows": [
        "moondream-3-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-compiled-megakernel-execution",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "runtime",
    "title": "Compiled megakernel execution",
    "impact": "Request handling, tokenization, and image decode stay on the CPU. Model execution runs inside one compiler-generated GPU program.",
    "models": [],
    "hardware": [],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally"
    }
  },
  {
    "id": "photon-2-0-md-photon-requires-moondream-sdk-0-11",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "compatibility",
    "title": "md.photon() requires moondream SDK 0.11+",
    "impact": "md.photon() needs moondream 0.11 or later. Earlier SDKs stay on Moondream-only local inference.",
    "models": [],
    "hardware": [],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally"
    }
  },
  {
    "id": "photon-2-0-photon-1-x-edge-support-ended",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "deprecation",
    "title": "Photon 1.x edge support ended",
    "impact": "Moondream 2 on A10 and Jetson AGX Orin is no longer supported for new deployments.",
    "models": [
      "Moondream 2"
    ],
    "hardware": [
      "A10",
      "Jetson AGX Orin"
    ],
    "knownLimitations": [
      "Photon 1.x configurations receive critical fixes only."
    ]
  }
];
